import { render, staticRenderFns } from "./StockAdjustmentView.vue?vue&type=template&id=6c398b26"
import script from "./StockAdjustmentView.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports